import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";

export const actionTypes = {
    UpdateClientProfile: "UPDATE_Client_PROFILE",
    ResetClientProfile: "RESET_Client_PROFILE",
};

const initialClientProfileState = {
    id: 0,
    name: "",
    email: "",
    primaryPhone: "",
    location: "",
    imageUrl: "",
};

export const reducer = persistReducer(
    { storage, key: "clientProfile", whitelist: ["id", "name", "email", "primaryPhone", "location", "imageUrl"] },
    (state = initialClientProfileState, action) => {

    switch (action.type) {
        case actionTypes.UpdateClientProfile: {
            return action.payload;
        }

        case actionTypes.ResetClientProfile: {
            return initialClientProfileState;
        }

        default:
            return state;
    }
});

export const actions = {
    updateClientProfile: (model) => ({ type: actionTypes.UpdateClientProfile, payload: model }),
    resetResetProfile: () => ({ type: actions.ResetClientProfile })
};
